import { render, staticRenderFns } from "./confirmarPedidoADistribuidor.vue?vue&type=template&id=2aa58971&scoped=true"
import script from "./confirmarPedidoADistribuidor.vue?vue&type=script&lang=js"
export * from "./confirmarPedidoADistribuidor.vue?vue&type=script&lang=js"
import style0 from "./confirmarPedidoADistribuidor.vue?vue&type=style&index=0&id=2aa58971&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa58971",
  null
  
)

export default component.exports